import { render, staticRenderFns } from "./AccEightColumnsBalanceDownload.vue?vue&type=template&id=4b701cec&lang=pug&"
import script from "./AccEightColumnsBalanceDownload.vue?vue&type=script&lang=js&"
export * from "./AccEightColumnsBalanceDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccEightColumnsBalanceDownload.vue"
export default component.exports